import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withProps,
  withPropsOnChange,
  withReducer,
} from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { path } from 'ramda';
import {
  getFirstFrom,
  getFirstTo,
  getSecondFrom,
  getSecondTo,
  getSelectedFilter,
  getFiltersForRange,
  isDirty,
} from '../selectors';
import filterReducer, { initialState } from '../../../common/RangeFilter/reducer';
import { setFilter, setCustomRange, setDirty, resetDirty } from '../actions';
import { AVAILABLE_FILTERS, FILTER_CUSTOM, FILTER_ONE_WEEK } from '../constants';
import { getBarberUserId, getShop, getTimezone } from '../../../auth/selectors';
import withDefaultEndingDate from '../../../main/reports/filters/containers/withDefaultEndingDate';

export default compose(
  withDefaultEndingDate(),
  setPropTypes({
    onDateChange: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    onFilterChange: PropTypes.func,
    initialState: PropTypes.shape({
      filters: PropTypes.arrayOf(PropTypes.oneOf(AVAILABLE_FILTERS)),
      selectedFilter: PropTypes.string,
      dates: PropTypes.object,
    }),
  }),
  withReducer(
    'filter',
    'dispatch',
    filterReducer,
    props => (props.initialState
      ? { ...initialState, ...props.initialState }
      : initialState
    ),
  ),
  withProps(props => ({
    filters: getFiltersForRange(props.filter),
    firstFrom: getFirstFrom(props.filter),
    firstTo: getFirstTo(props.filter),
    secondFrom: getSecondFrom(props.filter),
    secondTo: getSecondTo(props.filter),
    selectedFilter: getSelectedFilter(props.filter),
    setCustomRange: (...params) => setCustomRange(...params)(props.dispatch),
    setFilter: (...params) => setFilter(...params)(props.dispatch),
    onAfterFilterChange: props.onFilterChange,
  })),

  connect(
    state => ({
      shopId: getShop(state),
      barberId: getBarberUserId(state),
      timezone: getTimezone(state),
      isDirty: isDirty(state),
    }),
    {
      setDirty,
      resetDirty,
    }
  ),
  withHandlers({
    onFilterChange: props => key => () => props.setFilter(key),
    setFirstRange: props => (firstFrom, firstTo) => {
      props.setDirty();
      return props.setCustomRange(firstFrom, firstTo, props.secondFrom, props.secondTo);
    },
    setSecondRange: props => (secondFrom, secondTo) => {
      props.setDirty();
      return props.setCustomRange(props.firstFrom, props.firstTo, secondFrom, secondTo)
    },
    submitRange: props => () => {
      if (props.isFetching) return;

      props.resetDirty();
      props.onDateChange(props.firstFrom, props.firstTo, props.secondFrom, props.secondTo);
    },
  }),
  withPropsOnChange(
    ['selectedFilter'],
    (props) => {
      if (props.onAfterFilterChange) props.onAfterFilterChange(props.selectedFilter);
    }
  ),
  withPropsOnChange(
    ['firstFrom', 'firstTo', 'secondFrom', 'secondTo'],
    (props) => {
      if (props.isFetching || props.selectedFilter === FILTER_CUSTOM) return;
      props.onDateChange(props.firstFrom, props.firstTo, props.secondFrom, props.secondTo);
    }
  ),
  lifecycle({
    componentDidMount() {
      const initialFilter = path(['initialState', 'selectedFilter'], this.props) || FILTER_ONE_WEEK;
      this.props.setFilter(initialFilter);
    },
    componentWillUnmount() {
      this.props.resetDirty();
    },
  }),
);
